import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TaskStatusLookupComponent } from './task-status-lookup.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [TaskStatusLookupComponent],
  exports: [TaskStatusLookupComponent]
})
export class TaskStatusLookupModule { }
